import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAp2mTHZ2yG6JLul7Q55H1uEKOK3GQuFI0",
  authDomain: "seizoensplannen.firebaseapp.com",
  projectId: "seizoensplannen",
  storageBucket: "seizoensplannen.firebasestorage.app",
  messagingSenderId: "823488700684",
  appId: "1:823488700684:web:99adf6df2b07f0a30c6929",
  measurementId: "G-35TBFMWEYM"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
// Mails van Firebase Auth (wachtwoord instellen/resetten) in het Nederlands.
auth.languageCode = "nl";
// Cloud Functions draaien in Europa (België), dichtbij de gebruikers.
export const functions = getFunctions(app, "europe-west1");
